import { render, staticRenderFns } from "./BaseFieldCheck.vue?vue&type=template&id=76e52694&scoped=true"
import script from "./BaseFieldCheck.vue?vue&type=script&lang=js"
export * from "./BaseFieldCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e52694",
  null
  
)

export default component.exports